module.exports = __webpack_public_path__ + "img/icone_ppt.6a25235d.png";